import { gql, TypedDocumentNode } from "@apollo/client";

import {
  GetOrganizationByUuidQuery,
  GetOrganizationByUuidQueryVariables,
} from "./GetOrganization.generated";

const GET_ORGANIZATION_BY_UUID: TypedDocumentNode<
  GetOrganizationByUuidQuery,
  GetOrganizationByUuidQueryVariables
> = gql`
  query GetOrganizationByUuid(
    $uuid: String!
    $showBilling: Boolean = false
  ) {
    organization(uuid: $uuid) {
      name
      uuid
      createdAt
      location
      numTeams
      numUsers
      isManualBilling
      billingModeId
      canViewBilling
      stripeCustomerId
      allowsDirectMemberAdd
      canDeleteUsers
      emailDomain
      emailDomainSecondary
      emailDomainTertiary
      defaultTemplates {
        uuid
        name
        templateType
        description
        isFavourite
        sharingType
        createdAt
        updatedAt
      }
      teams {
        numUsers
        uuid
        name
        createdAt
        location
        isBillable @include(if: $showBilling)
        billableRoleCounts @include(if: $showBilling) {
          roleId
          roleName
          count
        }
        users {
          uuid
          firstName
          lastName
        }
      }
      admins {
        uuid
        firstName
        lastName
      }
    }
  }
`;

export default GET_ORGANIZATION_BY_UUID;
